"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomBoardState = getRandomBoardState;
const board_1 = require("@creature-chess/board");
const creatureDefinitions_1 = require("~/networking/creatureDefinitions");
const BOARD_SIZE = 8;
function getRandomBoardState(id, minPieces = 3) {
    var _a, _b;
    const board = new board_1.SubscribableBoard(BOARD_SIZE, BOARD_SIZE);
    const pieces = {};
    const definitionIds = (0, creatureDefinitions_1.getAvailableCreatureIds)();
    if (definitionIds.length === 0) {
        return { board, pieces };
    }
    const count = minPieces + Math.floor(Math.random() * 5);
    const placements = [];
    const used = new Set();
    let guard = 0;
    while (placements.length < count && guard < count * 10) {
        guard++;
        const x = Math.floor(Math.random() * BOARD_SIZE);
        const y = Math.floor(Math.random() * BOARD_SIZE);
        const key = `${x},${y}`;
        if (used.has(key)) {
            continue;
        }
        const definitionId = definitionIds[Math.floor(Math.random() * definitionIds.length)];
        const definition = (0, creatureDefinitions_1.getCreatureDefinitionById)(definitionId);
        if (!definition) {
            continue;
        }
        used.add(key);
        const pieceId = `${id}-${placements.length}`;
        pieces[pieceId] = {
            id: pieceId,
            // top half "away" (enemy), bottom half "home" (friendly)
            ownerId: y < BOARD_SIZE / 2 ? "away" : "home",
            definitionId,
            traits: definition.traits,
            stage: 0,
            maxHealth: (_b = (_a = definition.stages[0]) === null || _a === void 0 ? void 0 : _a.hp) !== null && _b !== void 0 ? _b : 1,
        };
        placements.push({ id: pieceId, x, y });
    }
    board.setPieces(placements);
    return { board, pieces };
}
